export default "__VITE_ASSET__BrnHxGYb__"